// extracted by mini-css-extract-plugin
module.exports = {"subTopicTitle":"SubTopicTitle_subTopicTitle__6WH20"};